import { render, staticRenderFns } from "./settings-events.vue?vue&type=template&id=5f2fc50f"
import script from "./settings-events.vue?vue&type=script&lang=js"
export * from "./settings-events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports